import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const ExpoTokenShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    ExpoToken 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    ExpoToken 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="토큰값" span={2} value={record?.token} />
                        <FieldItem label="장치ID" value={record?.deviceId} />
                        {/* 원본 삼항 유지 */}
                        <FieldItem
                            label="활성화여부"
                            value={record?.active ? "True" : "False"}
                        />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
